import React from 'react';
import { Datagrid, TextField } from 'react-admin';
import TList from 'cw-core-admin-ui/src/components/wrapper/TList';

export default ({ ...props }) => (
	<TList exporter={false} {...props}>
		<Datagrid>
			<TextField source="tokenId" />
			<TextField source="tokenSecret" />
			<TextField source="apiKey" />
		</Datagrid>
	</TList>
);
